module.exports = function getResource(label, vars = []) {
    let resources = {
        done: 'Done',
        close: 'Close',
        cancel: 'Cancel',
        continue: 'Continue',
        sephoraCreditCard: 'Sephora Credit Card',
        noThanks: 'No Thanks',
        acceptNow: 'Accept Now',
        fromTheRewardsBazaar: 'From the Rewards Bazaar',
        droppingTimeText: 'We’re dropping new rewards every Tuesday and Thursday 9am - 5pm PT. They go fast, so check back often to score one-of-a-kind experiences, personalized services and coveted sample rewards.',
        oops: 'Oops',
        cannotExtendText: 'We could not extend your session. Please try again later.',
        youEntered: 'You entered:',
        recommended: 'Recommended:',
        useTheAddress: 'Use the address I entered',
        extendSessionTitle: 'Extend session?',
        extendSessionButton: 'Extend session',
        sessionExpireText: `Your session will expire in ${vars[0]} min and ${vars[1]} sec due to inactivity.`,
        internationalShippingTitle: 'International Shipping',
        selectShippingCountry: 'Select a country you would like to ship to',
        redIndicationText: 'Note: Items that cannot be shipping to the location selected will be indicated in red.',
        itemsWillBeRemovedText: 'In order to checkout, these items will need to be removed from your basket.',
        continueWithShippingToUs: 'Continue with shipping to the US.',
        ifYouSelectCanadianShipping: 'If you select Canadian shipping, you will be taken to the Canadian site.',
        pricesWillBeShown: 'Prices will be shown in',
        atCheckoutOnly: 'at checkout only'
    };

    return resources[label];
};
